import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import React, { useState, useEffect } from 'react'
import SearchBox from 'src/components/common/SearchBox/SearchBox'
import './MessageList.scss'
import { useDispatch, useSelector } from 'react-redux'
import { setMessages, setSelectedChat } from 'src/redux/messages/messageSlice'
import { getMessageList, loadMore } from 'src/redux/messages/messageThunk'
import PropTypes from 'prop-types'
import { dateWithTime } from 'src/utils/dateTimeUtils'
import { providerLogin } from 'src/redux/user/userThunk'
import InfiniteScroll from 'react-infinite-scroll-component'
import { toast } from 'react-toastify'
import Logo from '../../../assets/Logo.svg'
import AILogo from 'src/assets/BlueLogo.svg'
import { convertHyphenDateToSlashDate } from '../../../utils/sharedFunctions'
import { GRAY_400 } from '../../../scss/colorConsts'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

const MessageList = ({ setText }) => {
  const dispatch = useDispatch()

  const tab = useSelector((state) => state.messages?.activeTab)
  const archiveLists = useSelector((state) => state.messages?.archiveList)
  const providerMsgLists = useSelector((state) => state.messages?.providerMsgList)
  const selectedChat = useSelector((state) => state.messages?.selectedChat)

  const currentUserId = useSelector((state) => state.user?.user?._id)

  const [archived, setArchived] = useState(archiveLists)
  const [providerHoldMsg, setProviderHoldMsg] = useState(providerMsgLists)
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)
  const [archivePage, setArchivePage] = useState(0)
  const [providerPage, setProviderPage] = useState(0)
  const [infiniteLoading, setInfiniteLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(tab)

  const handleActiveTab = async (e, selectedTab) => {
    e.preventDefault()

    setText('')
    setActiveTab({ ...activeTab, selected: selectedTab })
    setSearchText('')
    await dispatch(setMessages([]))
    await dispatch(setSelectedChat({}))
  }

  const loadData = async (messageType) => {
    if (messageType === 'Provider Hold') {
      return
    }
    setInfiniteLoading(true)

    let data = {
      q: '',
      page:
        messageType === 'Provider Hold'
          ? providerPage + 15
          : messageType === 'Archived'
            ? archivePage + 15
            : 0,
      type:
        messageType === 'Provider Hold' ? 'messages' : messageType === 'Archived' ? 'archive' : '',
    }

    let res = await dispatch(loadMore(data))

    if (res?.payload?.status === 'success' || res?.payload?.status === 'failure') {
      if (messageType === 'Provider Hold') {
        if (res?.payload?.data?.length !== 0) {
          setProviderPage(providerPage + 15)
        }
      } else if (messageType === 'Archived') {
        if (res?.payload?.data?.length !== 0) {
          setArchivePage(archivePage + 15)
        }
      }
    }
    setInfiniteLoading(false)
  }

  const getConversation = async (messageType, e) => {
    setLoading(true)
    let data = {
      q: '',
      page: 0,
      type:
        messageType === 'Provider Hold' ? 'messages' : messageType === 'Archived' ? 'archive' : '',
      currentUserId: currentUserId,
      tab: messageType,
    }

    await dispatch(getMessageList(data))

    setLoading(false)
  }

  const searchConversation = async (value) => {
    const messageType = activeTab?.selected
    setLoading(true)
    let data = {
      q: value,
      page: 0,
      type:
        messageType === 'Provider Hold' ? 'messages' : messageType === 'Archived' ? 'archive' : '',
      currentUserId: currentUserId,
      tab: messageType,
    }

    await dispatch(getMessageList(data))

    setLoading(false)
  }

  useEffect(() => {
    getConversation(activeTab?.selected)
    setActiveTab(tab)
  }, [tab])

  useEffect(() => {
    setLoading(true)
    activeTab.tabs.forEach((item) => {
      dispatch(
        getMessageList({
          q: searchText,
          page: 0,
          type:
            item.name === 'Provider Hold' ? 'messages' : item.name === 'Archived' ? 'archive' : '',
          tab: item?.name,
        }),
      )
    })
  }, [])

  useEffect(() => {
    if (activeTab?.selected === 'Provider Hold') {
      setProviderPage(0)
    } else if (activeTab?.selected === 'Archived') {
      setArchivePage(0)
    }
    setArchived(archiveLists)

    setProviderHoldMsg(providerMsgLists)
  }, [archiveLists, providerMsgLists])

  let FilterList =
    activeTab?.selected === 'Provider Hold'
      ? providerHoldMsg
      : activeTab?.selected === 'Archived'
        ? archived
        : []

  const currentPractice = useSelector((state) => state.user.practice)
  const currentProvider = useSelector((state) => state.user.provider)
  const Practice = useSelector((state) => state.user.practiceList)
  const Provider = useSelector((state) => state.user.providerList)

  const conversationSelected = async (conversation, index) => {
    let loggedInPractice = currentPractice
    let loggedInProvider = currentProvider
    let isProviderMapped = false
    let ispracticeMapped = false
    if (conversation.practice_id && conversation.practice_id === loggedInPractice?._id) {
      if (conversation.provider_id && conversation.provider_id === loggedInProvider?._id) {
        conversationThread(conversation)
      } else {
        Provider.forEach((provider) => {
          if (provider.provider_id === conversation.provider_id) {
            isProviderMapped = true
          }
        })
        if (isProviderMapped) {
          await dispatch(
            providerLogin({
              practice_id: conversation.practice_id,
              provider_id: conversation.provider_id,
            }),
          ).then((data) => {
            conversationThread(conversation)
          })
        } else {
          conversationThread(conversation)
        }
      }
    } else {
      Practice.forEach((practice) => {
        if (practice.practice_id === conversation.practice_id) {
          ispracticeMapped = true
        }
      })
      if (ispracticeMapped) {
        Provider.forEach((provider) => {
          if (provider.provider_id == conversation.provider_id) {
            isProviderMapped = true
          }
        })

        if (isProviderMapped) {
          await dispatch(
            providerLogin({
              practice_id: conversation.practice_id,
              provider_id: conversation.provider_id,
            }),
          ).then((data) => {
            toast.success('Practice changed to ' + conversation.practice_name)
            conversationThread(conversation)
          })
        } else {
          conversationThread(conversation)
        }
      } else {
        conversationThread(conversation)
      }
    }
  }

  const conversationThread = async (conversation) => {
    await dispatch(setSelectedChat(conversation))
    await dispatch(setMessages([]))
  }

  const conversationClickHandler = async (item, i) => {
    conversationSelected(item, i)
    setText('')
  }

  const debounce = (func, timeout) => {
    let timer
    return (...args) => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => func(...args), timeout)
    }
  }

  const refreshMessages = () => {
    getConversation('Archived')
    getConversation('Provider Hold')

    setLoading(true)
  }

  return (
    <CCard className="messageList">
      <CCardHeader className="messageList-header">
        <CRow className="justify-content-between">
          <CCol>
            <div className="messageList-header-left">
              Messages
              <span>
                <CButton
                  type="button"
                  color="secondary"
                  variant="ghost"
                  size="sm"
                  onClick={() => refreshMessages()}
                >
                  <i
                    style={{ fontSize: '1.25em' }}
                    className={`fa-sharp fa-light fa-arrows-rotate ${
                      loading ? 'rotate-animate' : ''
                    }`}
                  ></i>
                </CButton>
              </span>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol className="messageList-options">
            <CNav className="nav-items" variant="underline">
              {activeTab.tabs.map((item, i) => (
                <CNavItem key={i} className="message-tab-wrapper">
                  <CNavLink
                    onClick={(e) => handleActiveTab(e, item?.name)}
                    active={activeTab.selected === item.name}
                    className={activeTab.selected === item.name ? 'selected' : 'unselected'}
                  >
                    <span>{item?.name}</span>
                    <div className="message-other-number">
                      <p className="other-number">
                        {item?.name === 'Provider Hold'
                          ? providerHoldMsg?.length
                          : item?.name === 'Archived'
                            ? archived?.length
                            : ''}
                      </p>
                    </div>
                  </CNavLink>
                </CNavItem>
              ))}
            </CNav>
          </CCol>
        </CRow>
        <CRow>
          <CCol className="messageList-searchBar">
            <span>Search</span>
            <SearchBox
              placeholder="Search in messages..."
              type="messages"
              onChange={debounce(searchConversation, 1000)}
              value={searchText}
            />
          </CCol>
        </CRow>
      </CCardHeader>
      <InfiniteScroll
        dataLength={FilterList?.length + 20}
        next={() => {
          loadData(activeTab?.selected)
        }}
        hasMore={true}
        loader={infiniteLoading && <h4>Loading...</h4>}
        scrollableTarget="messageListid"
      >
        <CCardBody className="messageList-items" id="messageListid">
          {loading ? (
            <CSpinner color="primary" />
          ) : !loading && FilterList?.length > 0 ? (
            FilterList?.map((item, i) => {
              let titleEnd = item?.title?.length - 10 || 0
              let titleDate = item?.title?.slice(titleEnd)

              return (
                <CRow
                  className={
                    selectedChat?._id == item?._id ? 'singleConvo' : 'singleConvo-unselected'
                  }
                  key={i}
                >
                  <CCol
                    md={1}
                    onClick={() => conversationClickHandler(item, i)}
                    className="msgleft"
                  >
                    {item?.participants?.filter(
                      (pItem) => pItem?.user_id == item?.latest_message?.user_id,
                    )[0]?.showIcon === false ? (
                      <span>
                        {
                          item?.participants?.filter(
                            (pItem) => pItem?.user_id == item?.latest_message?.user_id,
                          )[0]?.displayInitials
                        }
                      </span>
                    ) : (
                      <img src={getIsAi() ? AILogo : Logo} alt="Claimocity Logo" />
                    )}
                    <div></div>
                  </CCol>
                  <CCol onClick={() => conversationClickHandler(item, i)} className="msgright">
                    <div className="msgtop">
                      <div className="msg-left">
                        <span>
                          {item?.title.slice(0, titleEnd)} {convertHyphenDateToSlashDate(titleDate)}
                        </span>
                        {item?.reason_codes && (
                          <>
                            <span className="reason-code">{item?.reason_codes[0]}</span>
                            {item?.reason_codes.length - 1 != 0 && (
                              <span className="reason-code">+{item?.reason_codes.length - 1}</span>
                            )}
                          </>
                        )}
                      </div>
                      <div className="msg-right">
                        <span>
                          {' '}
                          {dateWithTime(
                            item?.latest_message?.message_datetime || item.created_datetime,
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="msgbottom">
                      <span>
                        <strong>{item?.practice_name && item?.practice_name}</strong>
                        {item?.latest_message != null &&
                        item?.latest_message?.message_text != '' &&
                        item?.latest_message?.message_type === 1
                          ? ' - ' + item?.latest_message?.message_text
                          : item?.latest_message?.message_type === 2
                            ? 'Attachment Image'
                            : item?.latest_message?.message_type === 3
                              ? 'Attachment Audio'
                              : ''}
                      </span>
                    </div>
                  </CCol>
                </CRow>
              )
            })
          ) : !loading && FilterList?.length === 0 ? (
            <CRow className="singleConvo-nodata">
              <CCol md={1} className="msgleft-nodata">
                <i
                  className="fa-light fa-circle-user"
                  style={{ color: GRAY_400, fontSize: '2em' }}
                ></i>
              </CCol>
              <CCol className="msgright-nodata">
                <div className="msgtop-nodata">
                  <div className="msg-left-nodata">
                    <span>No messages</span>
                  </div>
                </div>
                <div className="msgbottom-nodata">
                  <span>You have no messages yet...</span>
                </div>
              </CCol>
            </CRow>
          ) : (
            <></>
          )}
        </CCardBody>
      </InfiniteScroll>
    </CCard>
  )
}
MessageList.propTypes = {
  messageThreadVisisble: PropTypes.bool,
  setThreadVisible: PropTypes.func,
}
export default MessageList
